/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_EmptyInputs */

const en_settings_videos_empty = /** @type {(inputs: Settings_Videos_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No videos yet.`)
};

/**
* | output |
* | --- |
* | "No videos yet." |
*
* @param {Settings_Videos_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_empty = /** @type {((inputs?: Settings_Videos_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_empty(inputs)
});
export { settings_videos_empty as "settings.videos.empty" }